import { themeObject } from '../../../../lib/util/themes/godzilla';

export const styles = {
    uploadDataDictionaryText: {
        fontFamily: 'Red Hat Text ',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '21.17px',
        textAlign: 'center',
        color: themeObject.palette.grayScale[800],
    },
};
